import Url from "url-parse";

import WebsiteBehaviors from "./website-behaviors/index.js";
import ResearchDatabase from "./website-behaviors/ResearchDatabase.js";
import PDF from "./website-behaviors/PDF.js";

import AMLegal from "./special-cases/AMLegal.js";
import APAPsycNET from "./special-cases/APAPsycNET.js";
import AspenLawEbooks from "./special-cases/AspenLawEbooks.js";
import AUCTR from "./special-cases/AUCTR.js";
import {Blackboard, BlackboardPdf} from "./special-cases/Blackboard.js";
import Bloomberg from "./special-cases/Bloomberg.js";
import Canvas from "./special-cases/Canvas.js";
import CiteseerxPdf from "./special-cases/CiteseerxPdf.js";
import Dropbox from "./special-cases/Dropbox.js";
import EbscoDiscovery from "./special-cases/EbscoDiscovery.js";
import EbscoEbooks from "./special-cases/EbscoEbooks.js";
import EbscoPdf from "./special-cases/EbscoPdf.js";
import EbscoHtml from "./special-cases/EbscoHtml.js";
import EbscoResearch from "./special-cases/EbscoResearch.js";
import EdX from "./special-cases/EdX.js";
import FrontiersIn from "./special-cases/FrontiersIn.js";
import Gale from "./special-cases/Gale.js";
import Hein from "./special-cases/Hein.js";
import IEEExplore from "./special-cases/IEEExplore.js";
import JLC from "./special-cases/JLC.js";
import JMSS from "./special-cases/JMSS.js";
import JSTOR from "./special-cases/JSTOR.js";
import JSTORPdf from "./special-cases/JSTORPdf.js";
import Lexis from "./special-cases/Lexis.js";
import Logos from "./special-cases/Logos.js";
import McGrawHillConnect from "./special-cases/McGrawHillConnect.js";
import Medium from "./special-cases/Medium.js";
import OJS from "./special-cases/OJS.js";
import Perlego from "./special-cases/Perlego.js";
import ProQuest from "./special-cases/ProQuest.js";
import ProQuestEbooks from "./special-cases/ProQuestEbooks.js";
import ProQuestPdf from "./special-cases/ProQuestPdf.js";
import ProQuestPrint from "./special-cases/ProQuestPrint.js";
import ProQuestCongressional from "./special-cases/ProQuestCongressional.js";
import ProQuestCongressionalPdf from "./special-cases/ProQuestCongressionalPdf.js";
import ReadCube from "./special-cases/ReadCube.js";
import RedShelf from "./special-cases/RedShelf.js";
import SciHub from "./special-cases/SciHub.js";
import SciHubPdf from "./special-cases/SciHubPdf.js";
import Twitter from "./special-cases/Twitter.js";
import Unizin from "./special-cases/Unizin.js";
import VitalSource from "./special-cases/VitalSource.js";
import WashingtonPost from "./special-cases/WashingtonPost.js";
import Westlaw from "./special-cases/Westlaw.js";
import Wikipedia from "./special-cases/Wikipedia.js";
import Wiley from "./special-cases/Wiley.js";

// For tests
const internals = {
	getTestMap: () => testMap
};

/**
 * An array so we can control order of evaluation.
 *
 * *********************************************************************************
 * DO NOT PUT THESE IN ALPHABETICAL ORDER, BUT RATHER ORDER OF PRECEDENCE. Thanks =)
 * *********************************************************************************
 *
 * @type {WebsiteBehaviors[]}
 */
const testMap = [
	Twitter,
	Westlaw,
	Lexis,
	Hein,
	Bloomberg,
	ProQuestEbooks,
	ProQuest,
	ProQuestPdf,
	ProQuestPrint,
	ProQuestCongressional,
	ProQuestCongressionalPdf,
	Wiley,
	VitalSource,
	RedShelf,
	APAPsycNET,
	ReadCube,
	WashingtonPost,
	Unizin,
	EbscoDiscovery,
	EbscoEbooks,
	EbscoPdf,
	EbscoHtml,
	EbscoResearch,
	McGrawHillConnect,
	Logos,
	JLC,
	CiteseerxPdf,
	AUCTR,
	Medium,
	JMSS, // should be before OJS
	OJS,
	FrontiersIn,
	Wikipedia,
	AMLegal,
	AspenLawEbooks,
	IEEExplore,
	Dropbox,
	Canvas,
	SciHub,
	SciHubPdf,
	Perlego,
	EdX,
	Blackboard,
	BlackboardPdf,
	JSTOR,
	JSTORPdf,
	Gale,

	ResearchDatabase, // This catches every research DB in the research-hosts.json file
	PDF // This catches all PDFs not already matched by a previous case
];

const byUrl: Record<string, WebsiteBehaviors> = {};

/**
 * @param {string}   url
 * @param {boolean}  isPdf
 * @param {Object}   hooks
 * @param {function} hooks.injectStyles
 * @param {function} hooks.renderAnnotations
 * @return {WebsiteBehaviors}
 */
// @ts-expect-error TS(7006) FIXME: Parameter 'url' implicitly has an 'any' type.
const getWebsiteBehaviors = (url: string, isPdf: boolean, hooks?): WebsiteBehaviors => {
	if (byUrl[url] !== undefined)
		return byUrl[url];

	// As far as I can tell, the url-parse lib produces something that behaves like a Location object.
	const location = new Url(url) as any as Location;

	let SelectedClass = WebsiteBehaviors;

	for (const CurrentClass of internals.getTestMap()) {
		if (CurrentClass.isPDF() !== isPdf)
			continue;

		try {
			if (CurrentClass.test(location)) {
				// @ts-expect-error FIXME
				SelectedClass = CurrentClass;
				break;
			}
		} catch (e) {
			// The OJS test, for example, blows up on some sites,
			// but we want to continue checking tests after it.
			const c = new CurrentClass(location);
			console.log("PN WebsiteBehaviors: " + c.identifier(), e);
		}
	}

	byUrl[url] = new SelectedClass(location, hooks);
	return byUrl[url];
};

export default getWebsiteBehaviors;

// Expose for testing purposes only
const __testObjs = (process.env.NODE_ENV === "test")
	? {byUrl, internals}
	: undefined;
export {__testObjs};
